<template>
  <b-container fluid class="news" style="padding: 0 1em;">
    <b-row class="justify-content-md-center">
      <b-col>
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
           fixed
          responsive
          bgcolor="#FFFFFF">
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="width: 1.25rem;"></b-th>
                <b-th style="min-width: 8rem;">
                  公告標題
                </b-th>
                <b-th style="width: 15rem;">
                  公告時間
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
            <b-tr>
                <b-td colspan="3" style="padding:0.3125em; text-align: left;">
                  <b-form-group v-slot="{ ariaDescribedby }" style="margin: 0;">
                    <!-- <b-button variant="info" size="sm"
                      @click="newDoc()"><b-icon icon="plus-square" aria-hidden="true"></b-icon>&nbsp;新增項目</b-button>&nbsp; -->
                    <b-form-radio-group
                      id="btn-radios-2"
                      v-model="mode"
                      :options="optionsV1"
                      :aria-describedby="ariaDescribedby"
                      button-variant="outline-primary"
                      size="sm"
                      name="radio-btn-outline"
                      buttons
                      v-show="0 < total"></b-form-radio-group>
                  </b-form-group>
                </b-td>
              </b-tr>
              <b-tr v-for="(item, index) in filteredCars" :key="item.id" :index="item.id" :name="item.id"
                  @click="rowClick(index, item)"
                  v-bind:class="{ selected: index == selectedRowIndex }">
                <b-td><b-icon icon="search"></b-icon></b-td>
                <b-td style="text-align: left;"><span class="span_text">{{item.text1}}</span></b-td>
                <b-td style="text-align: left; padding: 0.125em 0.3125em;">起:{{item.date1 | dateFormat}}&nbsp;迄:{{item.date2 | dateFormat}}</b-td>
              </b-tr>
            </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total>pageSize" />
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col>
        <div class='well'
          style="display:inline-table; padding: 0.1875em; width: 100%;"
          v-show="docRecord.newsId>-1 && detailShow==true">
          <table cellpadding="0" cellspacing="0" style="width:100%">
            <tbody>
              <tr>
                <td class="ncut-edit-form-text ncut-require-title" style="width:7rem;">角色：</td>
                <td class="ncut-base-form-ipt" style="padding-top: 15px;" colspan="3">
                  <b-form-select disabled multiple label-for="input-1" tabindex="1" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem; height: 5rem;"
                    v-model="roleItem"
                    placeholder="請選擇角色"
                    required>
                    <b-form-select-option
                      v-for="item in roleLst"
                      :key="item.text1"
                      :value="item.text1">{{item.text2}}</b-form-select-option>
                  </b-form-select>
                </td>
              </tr>
              <tr>
                <td class="ncut-edit-form-text">公告類型：</td>
                <td class="ncut-base-form-ipt" colspan="3">
                  <b-form-select disabled label-for="input-2" tabindex="2" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
                    v-model="docRecord.newsType"
                    placeholder="請選擇類型"
                    required>
                    <b-form-select-option
                      v-for="item in typeLst"
                      :key="item.id"
                      :value="item.id">{{item.text2}}</b-form-select-option>
                  </b-form-select>
                </td>
              </tr>
              <tr>
                <td class="ncut-edit-form-text">公告時間：</td>
                <td class="ncut-base-form-ipt" colspan="3">
                  <b-input-group>
                    <b-form-datepicker disabled v-model="docRecord.startDate" :max="docRecord.endDate" locale="zh-TW" required></b-form-datepicker>&nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                    <b-form-datepicker disabled v-model="docRecord.endDate" :min="docRecord.startDate" locale="zh-TW" required></b-form-datepicker>
                  </b-input-group>
                </td>
              </tr>
              <tr>
                <td class="ncut-edit-form-text ncut-require-title">公告標題：</td>
                <td class="ncut-base-form-ipt" colspan="3">
                  <b-form-input  disabled style="min-width:20rem;" :maxlength="50" tabindex="1"
                    v-model="docRecord.title" />
                </td>
              </tr>
              <tr>
                <td class="ncut-edit-form-text ncut-require-title">公告主題：</td>
                <td class="ncut-base-form-ipt" colspan="3">
                  <b-form-textarea disabled type="textarea"  tabindex="5"
                    :rows="8"
                    v-model="docRecord.content"
                    v-if="docRecord.newsType!=1"/>
                  <ckeditor :config="config" disabled tabindex="5"
                    v-model="docRecord.content"
                    v-else></ckeditor>
                </td>
              </tr>
              <!-- <tr>
                <td class="ncut-edit-form-text">是否顯示：</td>
                <td class="ncut-base-form-ipt">
                  <b-form-select label-for="input-2" tabindex="2" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
                    v-model="docRecord.isDelete"
                    placeholder="請選擇是否顯示"
                    required>
                    <b-form-select-option
                      v-for="item in optionsV2"
                      :key="item.value"
                      :value="item.value">{{item.text}}</b-form-select-option>
                  </b-form-select>
                </td>
                <td class="ncut-edit-form-text" style="width:8em;">是否顯示附件：</td>
                <td class="ncut-base-form-ipt">
                  <b-form-select label-for="input-2" tabindex="2" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
                    v-model="docRecord.isShow"
                    placeholder="請選擇是否顯示"
                    required>
                    <b-form-select-option
                      v-for="item in optionsV2"
                      :key="item.value"
                      :value="item.value">{{item.text}}</b-form-select-option>
                  </b-form-select>
                </td>
              </tr> -->
              <!-- <tr>
                <td class="ncut-edit-form-text ncut-require-title">置頂排序：</td>
                <td class="ncut-base-form-ipt" colspan="3" style="padding: 1rem;">
                  <b-form-input id="range-1" v-model="docRecord.sort" type="range" min="0" max="100" tabindex="8"></b-form-input>
                  <div class="mt-2">排序：<font size="+1" style="color:#411c35;">{{ docRecord.sort }}</font>（預設為 0，可決定公告置頂，數字越大順位越高。）</div>
                </td>
              </tr> -->
              <tr>
<td>附件:</td>
<td class="ncut-base-form-ipt" colspan="3">
<ul style="clear:both" v-show="docRecord.info!=null && docRecord.info.length > 0" class="response">
                    <li class="sel-file" v-for="f in docRecord.info" :key="f.menuID" :index="f.menuID" :name="f.menuID"
                      v-show="f.status!='D'">
                      <a :href="'./WebApi/Common/GetAttach/'+f.rowId" target="_blank"
                        :title="f.name">
                        <img v-if="f.img != null" :src="f.img" style="width:1.38em; height:1.38em;">
                        <span v-if="f.img == null">
                          <img v-if="f.type === 'application/msword'" src="@/assets/images/word.gif" style="width:1.5em; height:1.5em;">
                          <img v-else-if="f.type === 'image/jpeg'" src="@/assets/images/image.gif" style="width:1.5em; height:1.5em;">
                          <img v-else-if="f.type === 'application/pdf'" src="@/assets/images/pdf.gif" style="width:1.5em; height:1.5em;">
                          <img v-else src="@/assets/images/attachment.png" style="width:1.5em; height:1.5em;">
                        </span>{{f.name}}.{{f.ext}}
                      </a>

                    </li>
                  </ul>

</td>

              </tr>
              <!-- <tr>
                <td class="ncut-edit-form-text">
                  <b-icon icon="upload"/>附件上傳：
                </td>
                <td class="ncut-base-form-ipt" colspan="3">
                  <ul style="clear:both" v-show="docRecord.info!=null && docRecord.info.length > 0" class="response">
                    <li class="sel-file" v-for="f in docRecord.info" :key="f.menuID" :index="f.menuID" :name="f.menuID"
                      v-show="f.status!='D'">
                      <a :href="'./WebApi/Common/GetAttach/'+f.rowId" target="_blank"
                        :title="f.name">
                        <img v-if="f.img != null" :src="f.img" style="width:1.38em; height:1.38em;">
                        <span v-if="f.img == null">
                          <img v-if="f.type === 'application/msword'" src="@/assets/images/word.gif" style="width:1.5em; height:1.5em;">
                          <img v-else-if="f.type === 'image/jpeg'" src="@/assets/images/image.gif" style="width:1.5em; height:1.5em;">
                          <img v-else-if="f.type === 'application/pdf'" src="@/assets/images/pdf.gif" style="width:1.5em; height:1.5em;">
                          <img v-else src="@/assets/images/attachment.png" style="width:1.5em; height:1.5em;">
                        </span>{{f.name}}.{{f.ext}}
                      </a>
                      &nbsp;&nbsp;
                      <b-icon icon="trash" title="移除附件"
	                      @click="f.status='D'"/>
                    </li>
                  </ul>
                  <b-form-file ref="file-input" class="dragdrop" tabindex="9"
                    v-model="file"
                    @input="fileChange"
                    :state="Boolean(file)"
                    browse-text="上傳"
                    placeholder="將文件拖到此處，或點擊上傳..."
                    drop-placeholder="移除檔案..."
                    accept="image/jpeg, image/png, image/gif, application/pdf, application/msword">></b-form-file>
                  <p>{{ file ? file.name : '' }}</p>
                </td>
              </tr> -->
            </tbody>
          </table>
          <!-- <div style='text-align: left;'>
            <font style="color:red;">* 紅色為必填欄位</font>
          </div> -->
          <!-- <b-row style="padding: 0.25em 2em; display: initial;">
            <b-button variant="success" tabindex="10"
              @click="save()"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
            <b-button variant="danger" style="float: right;" tabindex="11"
              @click="remove()"><b-icon icon="trash"/>&nbsp;{{$t('message.Del_cmd')}}</b-button>
          </b-row> -->
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import * as tools from '@/tool';
import Ckeditor from 'vue-ckeditor2'
export default {
  name: 'news',
  components: {
    Ckeditor
  },
  data () {
    return {
      detailShow: false,
      file: undefined,
      formData: undefined,
      fileList: [],
      optionsV1: [
          { text: '全部',   value: '1' },
          { text: '要顯示', value: '2' },
          { text: '不顯示', value: '3' }
        ],
      optionsV2: [
          { text: '是', value: false },
          { text: '否', value: true }
        ],
      tmpDate: [new Date(), new Date()],
      roleItem: [],
      docRecordList: [],
      docRecord: {
        newsId: -1,
        roleId: [],
        info: []
      },
      roleLst: [],
      typeLst: [],
      mode: '1',
      currentPage: 1,
      selectedRowIndex: 0,
      pageSize: 10,
      total: 0,
      config: {
        toolbar: [
          [ 'Source', '-','Preview', '-', 'Templates' ],
          [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ],
          [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ],
          [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ],
          [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ],
          [ 'Link', 'Unlink', 'Anchor' ],
          [ 'Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] ,
          [ 'Styles', 'Format', 'Font', 'FontSize' ],
          [ 'TextColor', 'BGColor' ] ,
          [ 'Maximize', 'ShowBlocks' ] ,
          [ 'About' ]
        ]
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
  	filteredCars: function(){
    	var cars = []
    	if(this.mode == '0'){
      	cars = this.docRecordList
      }
      else
      {
        cars = this.docRecordList.filter(car => {
          switch(this.mode) {
            case '1':
              return true
              break;
            case '2':
              if (!car.flag) {
                return true
              }
              break;
            case '3':
              if (car.flag) {
                return true
              }
              break;
          }
          return false
        })
      }
      return cars.slice((this.currentPage-1)*this.pageSize, this.currentPage*this.pageSize)
    }
  },
  filters: {
    dateFormat:function(input) {
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
       return  year+ '/' + month + '/' + day ;
    }
  },
  methods: {
    isShow (item) {
      return (tools.isNull(item.status) || item.status!='D')
    },
    rowClick(index, item) {
      var vm = this
      this.fileList = [];
      this.selectedRowIndex = index;
      this.docRecord =  {
        newsId: -1,
        roleId: [],
        info: []
      };
      this.$http
        .get('./WebApi/Setting/GetSystemNews/'.concat(item.id))
        .then(function(response) {
          vm.docRecord = response.data
          if (!tools.isNull(vm.docRecord)) {
            vm.detailShow =true;
            vm.roleItem = vm.docRecord.roleId.split(",")
            vm.tmpDate = [ vm.docRecord.startDate, vm.docRecord.endDate]
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    newDoc() {
      var vm = this
      this.selectedRowIndex = -1
      this.fileList = [];
      this.docRecord = {
        newsId: -1,
        roleId: [],
        info: []
      }
      this.$http
        .get('./WebApi/Setting/GetSystemNews/0')
        .then((response) => {
          vm.docRecord = response.data
          if (!tools.isNull(vm.docRecord)) {
            vm.detailShow = true;
            vm.roleItem = []
            vm.docRecord.sysId = this.sysId
            vm.tmpDate = [ new Date(), new Date()]
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    checkSaveData () {
      let msg = ''

      if (tools.isNull(this.roleItem) || (this.roleItem.length === 0)) {
        msg = '請選擇角色';
      } else if (this.docRecord.content === '') {
        msg = '請輸入公告主題';
      } else if (tools.isNull(this.docRecord.content) || (1200 < this.docRecord.content.length)) {
        msg = '公告內容最多 1200 個字';
      } else {
        if (!tools.isNull(this.fileList) && (this.fileList.length>0)) {
          if (tools.isNull(this.docRecord.info)) {
            this.docRecord.info = this.fileList;
          } else {
            var len = this.fileList.length;
            for (var it = 0; it < len; it++) {
              this.docRecord.info.push(this.fileList[it]);
            }
          }
        }
        if ((2 == this.docRecord.newsType) && (tools.isNull(this.docRecord.info) || (this.docRecord.info.length == 0))) {
          msg = '請選擇附件';
        } else {
          this.docRecord.roleId = (this.roleItem.length>1?this.roleItem.join():this.roleItem[0])
          this.roleItem = [];
        }
      }

      return msg
    },
    remove () {
      var vm = this
      this.$http.get('./WebApi/Setting/RemoveSystemNews/'.concat(this.docRecord.newsId))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,存檔成功');
            vm.getList();
            this.detailShow=false;
          }
          else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗');
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    save () {
      var vm = this
      let msg = this.checkSaveData()
      if (msg.length === 0) {
        this.docRecord.updateUser = this.$store.getters.getUser.id;
        this.$http.put('./WebApi/Setting/SetSystemNews', this.docRecord)
          .then((response) => {
            if (response.data) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功');
              vm.getList ()
              vm.roleItem = vm.docRecord.roleId.split(",")
            }
            else {
              tools.showAlert(vm, 'danger', '對不起,存檔失敗');
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error);
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,' + msg);
        return false;
      }
    },
    getRoleName: function () {
      return this.$http
                 .get('./WebApi/Common/GetRoleName/'.concat(this.sysId));
    },
    getTypeSet: function () {
      return this.$http
                 .get('./WebApi/Common/GetCodeNameToInt/'.concat(this.sysId).concat("/NewsType"));
    },
    getMailItem: function () {
      var vm = this
      this.mailInfo = {
          subjText: '',
          contText: '',
          ishtml: false
      }
      this.$http
        .get('./WebApi/Setting/GetFormatData/'.concat(this.sysId).concat('/').concat(this.fmtType).concat('/').concat(this.mailType))
        .then(function(response) {
          vm.mailInfo = response.data
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    getList () {
      var vm = this
      this.selectedRowIndex = 0;
      this.currentPage = 1;
      this.total = 0;
      this.docRecordList = [];
      this.$http
        .get('./WebApi/Setting/GetNewsTitle/'.concat(this.sysId))
        .then(function(response) {
          vm.docRecordList = response.data
          vm.total = vm.docRecordList.length
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    clearImg() {
      if (!tools.isNull(this.docRecord.info) &&
          this.docRecord.info.length>0) {
        var fLen = this.docRecord.info.length;
        for (var i = 0; i < fLen; i++) {
          this.docRecord.info[i].status = 'D';
        }
      }
      this.$refs["file-input"].reset();
    },
    checkFiles()
    {
      var ret = false;
      var fLen = this.fileList.length;
      var fType = ['image/jpeg', 'image/gif','image/png', 'application/pdf', 'application/msword'];
      for (var i = 0; i < fLen && !ret; i++) {
        const isIMAGE = fType.includes(this.fileList[i].type);
        const isLt1M = this.fileList[i].size > 10485760;

        if (!isIMAGE) {
          tools.showAlert(vm, 'danger', '文件格式不支援!');
        }
        if (isLt1M) {
          tools.showAlert(vm, 'danger', '檔案大小請勿超過 10MB!');
        }
        ret = (!isIMAGE || isLt1M);
      }
      return ret;
    },
    fileChange(e) {
      var vm = this;
      this.formData = new FormData();
      this.formData.append('header', this.file); //放進上傳的檔案
      this.$http.post('./WebApi/Common/UploadV2', this.formData)
            .then((response) => {
              if (!tools.isNull(response.data)) {
                var file = response.data[0];
                vm.fileList.push(file);
                // vm.docRecord.info = [];
                // vm.docRecord.info.push(response.data);
              }
              else {
                tools.showAlert(vm, 'danger', '上傳檔案失敗' + error);
              }
            })
            .catch(function (error) {
              tools.showAlert(vm, 'danger', '網路連線失敗' + error);
            })
    },
  },
  created () {
    //console.log('== News ==')
    var vm = this
    this.$http.all([this.getRoleName(), this.getTypeSet()])
      .then(vm.$http.spread(function (data1, data3) {
        if (!tools.isNull(data1)) {
          vm.roleLst = data1.data
        }
        if (!tools.isNull(data3)) {
          vm.typeLst = data3.data
        }
        vm.getList()
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.span_text {
    display: block;
    width: 11.25rem;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
</style>
